import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'reactstrap'

/**
 * View for confirming information on the school and assessment
 * for which data is about to be uploaded via CSV. 
 */
function InfoConfirmation ({
  school, 
  district, 
  schoolYear, 
  assessment,
}) {
  return (
    <Alert>
      <h3>School: {school}</h3>
      <ul>
        <li>District: {district}</li>
        <li>School Year: {schoolYear}</li>
        <li>Assessment: {assessment}</li>
      </ul>
    </Alert>
  )
}

const { string } = PropTypes

InfoConfirmation.propTypes = {
  school: string.isRequired, 
  district: string.isRequired, 
  schoolYear: string.isRequired, 
  assessment: string.isRequired,
}

export default InfoConfirmation


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/InfoConfirmation.js